import React from "react";
import { ListingData } from "shared-components/ViewFragments/SearchPage/ListingCard";
import { HomeProjectsCarouselSection } from "./web";

interface ProjectsSearchResult {
	searchFast?: {
		data?: ListingData[];
	};
}

interface HomeProjectsCarouselsProps {
	projectsResult?: {
		vis?: ProjectsSearchResult;
		nonVis?: ProjectsSearchResult;
	} | null;
}

export const HomeProjectsCarousels: React.FC<HomeProjectsCarouselsProps> = ({
	projectsResult = null,
}) => {
	const visItems = projectsResult?.vis?.searchFast?.data || [];
	const nonVisItems = projectsResult?.nonVis?.searchFast?.data || [];

	if (!visItems.length && !nonVisItems.length) {
		return null;
	}

	return (
		<>
			<HomeProjectsCarouselSection
				sectionClassName="proyectos-vivienda-no-vis-container"
				carouselTitle="proyectos-vivienda-no-vis"
				title="Proyectos"
				subtitle="Descubre proyectos con distintas tipologías, ubicaciones y niveles de inversión."
				viewAllLabel="Ver todos los proyectos →"
				viewAllHref="/proyectos-vivienda"
				items={nonVisItems}
			/>
			<HomeProjectsCarouselSection
				sectionClassName="proyectos-vivienda-vis-container"
				carouselTitle="proyectos-vivienda-vis"
				title="Proyectos VIS"
				subtitle="Opciones de vivienda con precios más accesibles y posibilidad de subsidio."
				viewAllLabel="Ver todos los proyectos →"
				viewAllHref="/proyectos-vivienda/vivienda-vis"
				items={visItems}
			/>
		</>
	);
};
